export default function Cards() {
  return (
    <section id="cards" className="py-16 md:py-20 px-4 md:px-6 bg-background-950">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-secondary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">精选推荐</h2>
          <span className="text-xs text-foreground-500 bg-background-800/70 px-3 py-1 rounded-full">口碑佳作</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <div className="group rounded-2xl overflow-hidden bg-background-800/20 border border-background-700/20 hover:border-accent-500/25 transition-all cursor-pointer">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Epic%20Chinese%20period%20drama%20scene%20with%20vast%20army%20and%20battlefield%2C%20cinematic%20golden%20sunset%20lighting%2C%20dramatic%20composition%2C%20large%20scale%20film%20still%20aesthetic&width=700&height=400&seq=card-1&orientation=landscape"
                alt="封神第二部"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base font-bold text-foreground-100 group-hover:text-accent-400 transition-colors">封神第二部：战火西岐</h3>
              <p className="text-xs text-foreground-500 mt-2 line-clamp-2">姜子牙率领西岐大军对抗殷商，神话史诗战争全面爆发。宏大视效与深刻情感交织，国产奇幻巅峰之作。</p>
              <div className="flex items-center gap-3 mt-3">
                <span className="text-xs text-accent-400 font-semibold">9.2分</span>
                <span className="text-xs text-foreground-600">2025·奇幻·动作</span>
              </div>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-800/20 border border-background-700/20 hover:border-accent-500/25 transition-all cursor-pointer">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Inspirational%20Chinese%20drama%20scene%20with%20female%20boxer%20training%20in%20gym%2C%20intense%20determination%2C%20warm%20cinematic%20lighting%2C%20motivational%20film%20still%20aesthetic&width=700&height=400&seq=card-2&orientation=landscape"
                alt="热辣滚烫"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base font-bold text-foreground-100 group-hover:text-accent-400 transition-colors">热辣滚烫</h3>
              <p className="text-xs text-foreground-500 mt-2 line-clamp-2">乐莹用拳击重塑人生，从自暴自弃到站上擂台。一场关于自我救赎的燃情故事，笑中带泪的力量之作。</p>
              <div className="flex items-center gap-3 mt-3">
                <span className="text-xs text-accent-400 font-semibold">9.0分</span>
                <span className="text-xs text-foreground-600">2024·剧情·运动</span>
              </div>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-800/20 border border-background-700/20 hover:border-accent-500/25 transition-all cursor-pointer">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20urban%20drama%20scene%20with%20delivery%20rider%20in%20city%20streets%20at%20night%2C%20neon%20lights%2C%20touching%20slice%20of%20life%2C%20cinematic%20realistic%20film%20still&width=700&height=400&seq=card-3&orientation=landscape"
                alt="逆行人生"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base font-bold text-foreground-100 group-hover:text-accent-400 transition-colors">逆行人生</h3>
              <p className="text-xs text-foreground-500 mt-2 line-clamp-2">高志垒从程序员到外卖骑手，在逆行中重新发现生活的意义。普通人面对困境的坚韧与温情，直击人心。</p>
              <div className="flex items-center gap-3 mt-3">
                <span className="text-xs text-accent-400 font-semibold">8.8分</span>
                <span className="text-xs text-foreground-600">2024·剧情·家庭</span>
              </div>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-800/20 border border-background-700/20 hover:border-accent-500/25 transition-all cursor-pointer">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Crime%20investigation%20Chinese%20drama%20scene%20with%20detectives%20in%20dark%20interrogation%20room%2C%20intense%20dramatic%20lighting%2C%20suspenseful%20atmosphere%2C%20gritty%20realistic%20film%20still&width=700&height=400&seq=card-4&orientation=landscape"
                alt="三大队"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base font-bold text-foreground-100 group-hover:text-accent-400 transition-colors">三大队</h3>
              <p className="text-xs text-foreground-500 mt-2 line-clamp-2">刑警程兵出狱后以普通人身份继续追凶十二年。根据真实事件改编，一场跨越时间的执念与正义。</p>
              <div className="flex items-center gap-3 mt-3">
                <span className="text-xs text-accent-400 font-semibold">9.3分</span>
                <span className="text-xs text-foreground-600">2023·犯罪·剧情</span>
              </div>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-800/20 border border-background-700/20 hover:border-accent-500/25 transition-all cursor-pointer">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Shanghai%20period%20drama%20scene%20with%20elegant%20characters%20in%201990s%20setting%2C%20nostalgic%20warm%20lighting%2C%20stylish%20cinematic%20composition%2C%20retro%20aesthetic%20film%20still&width=700&height=400&seq=card-5&orientation=landscape"
                alt="繁花"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base font-bold text-foreground-100 group-hover:text-accent-400 transition-colors">繁花</h3>
              <p className="text-xs text-foreground-500 mt-2 line-clamp-2">九十年代上海，阿宝在股市与商海中沉浮起落。王家卫镜头下的上海滩，霓虹光影中的时代传奇。</p>
              <div className="flex items-center gap-3 mt-3">
                <span className="text-xs text-accent-400 font-semibold">8.7分</span>
                <span className="text-xs text-foreground-600">2024·剧情·爱情</span>
              </div>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-800/20 border border-background-700/20 hover:border-accent-500/25 transition-all cursor-pointer">
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20workplace%20comedy%20drama%20scene%20with%20office%20workers%20in%20annual%20party%2C%20colorful%20festive%20lighting%2C%20humorous%20atmosphere%2C%20lively%20cinematic%20film%20still&width=700&height=400&seq=card-6&orientation=landscape"
                alt="年会不能停"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base font-bold text-foreground-100 group-hover:text-accent-400 transition-colors">年会不能停！</h3>
              <p className="text-xs text-foreground-500 mt-2 line-clamp-2">钳工胡建林阴差阳错调入集团总部，在年会筹备中掀起职场喜剧风暴。笑料百出的讽刺喜剧，打工人必看。</p>
              <div className="flex items-center gap-3 mt-3">
                <span className="text-xs text-accent-400 font-semibold">8.3分</span>
                <span className="text-xs text-foreground-600">2023·喜剧·剧情</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}